import React from 'react';

import Select from 'react-select';

import { GOAL_CLOSED_OPTIONS, GOAL_IN_PROGRESS_OPTIONS } from 'constants/ProjectConstants';

const getDefaultSelectedOption = (progressLevel) => {
  const filteredOptions = [...GOAL_IN_PROGRESS_OPTIONS, ...GOAL_CLOSED_OPTIONS].filter(
    ({ value }) => value === progressLevel
  );
  return filteredOptions.length === 1 ? filteredOptions[0] : null;
};

const options = [
  {
    label: 'In Progress',
    options: GOAL_IN_PROGRESS_OPTIONS,
  },
  {
    label: 'Closure',
    options: GOAL_CLOSED_OPTIONS,
  },
];

export default function GoalProgressSelect({ disabled, progressLevel, goalClosureStatus, onChange, ...props }) {
  return (
    <Select
      isDisabled={disabled}
      classNamePrefix="react-select"
      label="Single select"
      options={options}
      value={
        progressLevel === 'CLOSED'
          ? getDefaultSelectedOption(goalClosureStatus)
          : getDefaultSelectedOption(progressLevel)
      }
      onChange={onChange}
      styles={colourStyles}
      theme={(theme, data) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: 'lightGrey',
        },
      })}
      {...props}
    />
  );
}

const dot = (color = '#ccc') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
});

const colourStyles = {
  dropdownIndicator: (styles, data) => ({
    ...styles,
    color: 'transparent',
    padding: '4px',
  }),
  indicatorSeparator: (styles, data) => ({
    ...styles,
    backgroundColor: 'transparent',
  }),
  control: (styles, data) => {
    const color = '#ccc';
    return {
      ...styles,
      backgroundColor: 'white',
      fontSize: '13px',

      width: '20ch',
      minHeight: '30px',
      boxShadow: 'none',
      borderColor: 'transparent',
      cursor: 'pointer',
      ':hover': {
        ...styles[':hover'],
        borderColor: color,
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':focus': {
        ...styles[':focus'],
        borderColor: color,
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
      ':active': {
        ...styles[':active'],
        '& .react-select__dropdown-indicator': { color },
        '& .react-select__indicator-separator': { backgroundColor: color },
      },
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const hoverColor = '#F9F9F9';
    const selectedColor = '#F0F0F0';
    return {
      ...styles,
      backgroundColor: isSelected ? selectedColor : isFocused ? hoverColor : null,
      color: data.color,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      fontSize: '13px',

      ':active': {
        ...styles[':active'],
        backgroundColor: isSelected ? selectedColor : hoverColor,
      },
      ...dot(data.color),
    };
  },
  input: (styles, state) => styles,
  singleValue: (styles, { data }) => ({ ...styles, color: data.color }),
};
